import React from 'react';
import AdminHiringTemplatesPage from '../domains/admin/components/AdminHiringTemplatesPage';

const AdminHiringTemplates: React.FC = () => {
  return <AdminHiringTemplatesPage />;
};

export default AdminHiringTemplates;
